export interface TimelineDataPoint {
  date: string
  index: number
  phase: 'Baseline' | 'Flight' | 'Post-Flight'
}

export interface AudienceSegment {
  name: string
  index: number
  category: string
}

export interface Publisher {
  name: string
  category: string
  tier: 'National Media' | 'Category Leader' | 'Premium Vertical'
  reach: string
  description: string
  logoUrl?: string
}

export const timelineData: TimelineDataPoint[] = [
  // Phase 1: Baseline (Dec 9-14) - Index ~100
  { date: 'Dec 9', index: 98, phase: 'Baseline' },
  { date: 'Dec 10', index: 101, phase: 'Baseline' },
  { date: 'Dec 11', index: 99, phase: 'Baseline' },
  { date: 'Dec 12', index: 102, phase: 'Baseline' },
  { date: 'Dec 13', index: 100, phase: 'Baseline' },
  { date: 'Dec 14', index: 100, phase: 'Baseline' },

  // Phase 2: Flight (Dec 15-31) - Index ~133 (Spike)
  { date: 'Dec 15', index: 115, phase: 'Flight' },
  { date: 'Dec 16', index: 128, phase: 'Flight' },
  { date: 'Dec 17', index: 135, phase: 'Flight' },
  { date: 'Dec 18', index: 138, phase: 'Flight' },
  { date: 'Dec 19', index: 132, phase: 'Flight' },
  { date: 'Dec 20', index: 130, phase: 'Flight' },
  { date: 'Dec 21', index: 136, phase: 'Flight' },
  { date: 'Dec 22', index: 140, phase: 'Flight' },
  { date: 'Dec 23', index: 134, phase: 'Flight' },
  { date: 'Dec 24', index: 125, phase: 'Flight' }, // Slight dip for Xmas eve maybe?
  { date: 'Dec 25', index: 120, phase: 'Flight' },
  { date: 'Dec 26', index: 128, phase: 'Flight' },
  { date: 'Dec 27', index: 135, phase: 'Flight' },
  { date: 'Dec 28', index: 139, phase: 'Flight' },
  { date: 'Dec 29', index: 133, phase: 'Flight' },
  { date: 'Dec 30', index: 131, phase: 'Flight' },
  { date: 'Dec 31', index: 129, phase: 'Flight' },

  // Phase 3: Post-Flight (Jan 1-7) - Index ~114 (Sustained)
  { date: 'Jan 1', index: 118, phase: 'Post-Flight' },
  { date: 'Jan 2', index: 115, phase: 'Post-Flight' },
  { date: 'Jan 3', index: 114, phase: 'Post-Flight' },
  { date: 'Jan 4', index: 112, phase: 'Post-Flight' },
  { date: 'Jan 5', index: 116, phase: 'Post-Flight' },
  { date: 'Jan 6', index: 113, phase: 'Post-Flight' },
  { date: 'Jan 7', index: 114, phase: 'Post-Flight' },
]

export const audienceSegments: AudienceSegment[] = [
  { name: 'Pension Planning', index: 250, category: 'Finance' },
  { name: 'Dining & Lifestyle', index: 185, category: 'Lifestyle' },
  { name: 'Health & Wellness', index: 145, category: 'Health' },
  { name: 'Travel Enthusiasts', index: 130, category: 'Travel' },
]

export const publishers: Publisher[] = [
  // News & Current Affairs
  {
    name: 'RTL Nieuws & Entertainment',
    category: 'News',
    tier: 'National Media',
    reach: 'Mass reach',
    description: 'Leading Dutch news & entertainment',
  },
  {
    name: 'Mediacourant.nl',
    category: 'News',
    tier: 'National Media',
    reach: 'Entertainment news',
    description: 'Media & entertainment coverage',
  },
  {
    name: 'Welingelichte Kringen',
    category: 'News',
    tier: 'National Media',
    reach: 'News aggregation',
    description: 'Curated news & analysis',
  },
  {
    name: 'De Dagelijkse Standaard',
    category: 'News',
    tier: 'National Media',
    reach: 'Opinion & commentary',
    description: 'Political opinion platform',
  },
  {
    name: 'Headliner.nl',
    category: 'News',
    tier: 'National Media',
    reach: 'News overview',
    description: "Netherlands' largest news overview",
  },
  {
    name: 'FOK!',
    category: 'News',
    tier: 'National Media',
    reach: 'News & forum',
    description: 'News discussion community',
  },

  // Food & Lifestyle
  {
    name: 'Eef Kookt Zo',
    category: 'Food',
    tier: 'Category Leader',
    reach: 'Popular recipes',
    description: 'Trusted recipe platform',
  },
  {
    name: "Laura's Bakery",
    category: 'Food',
    tier: 'Category Leader',
    reach: 'Baking community',
    description: 'Premium baking & lifestyle',
  },
  {
    name: 'Uit Paulines Keuken',
    category: 'Food',
    tier: 'Category Leader',
    reach: 'Lifestyle food',
    description: 'Food & lifestyle inspiration',
  },
  {
    name: 'Miljuschka',
    category: 'Food',
    tier: 'Category Leader',
    reach: 'TV chef & magazine',
    description: 'Celebrity chef recipes',
  },
  {
    name: 'Rutger Bakt',
    category: 'Food',
    tier: 'Category Leader',
    reach: 'Baking expert',
    description: 'Heel Holland Bakt winner',
  },
  {
    name: 'Leuke Recepten',
    category: 'Food',
    tier: 'Category Leader',
    reach: 'Recipe collection',
    description: 'Family-friendly recipes',
  },

  // Sport & Automotive
  {
    name: 'WielerFlits',
    category: 'Sport',
    tier: 'Premium Vertical',
    reach: '50+ cycling fans',
    description: 'Leading cycling news platform',
  },
  {
    name: 'F1 & Max Verstappen News',
    category: 'Sport',
    tier: 'Premium Vertical',
    reach: 'Formula 1 coverage',
    description: 'F1 news & analysis',
  },
  {
    name: 'FCUpdate.nl',
    category: 'Sport',
    tier: 'Premium Vertical',
    reach: 'Football news',
    description: 'Live football & transfers',
  },
  {
    name: 'Soccernews.nl',
    category: 'Sport',
    tier: 'Premium Vertical',
    reach: 'Football coverage',
    description: "Netherlands' largest football news",
  },
  {
    name: 'Autobahn',
    category: 'Sport',
    tier: 'Premium Vertical',
    reach: 'Automotive enthusiasts',
    description: 'Car news & reviews',
  },
  {
    name: 'Racing News',
    category: 'Sport',
    tier: 'Premium Vertical',
    reach: 'Motorsport coverage',
    description: 'Formula 1 & racing news',
  },

  // Radio & Weather (Contextual)
  {
    name: 'Nederland.FM',
    category: 'Radio',
    tier: 'Premium Vertical',
    reach: 'Online radio',
    description: 'Radio streaming platform',
  },
  {
    name: 'Radio Luisteren',
    category: 'Radio',
    tier: 'Premium Vertical',
    reach: 'Radio portal',
    description: 'Dutch radio stations',
  },
  {
    name: 'Weerplaza.nl',
    category: 'Radio',
    tier: 'Premium Vertical',
    reach: 'Weather forecasts',
    description: 'Weather & radar services',
  },
  {
    name: 'Buienradar (RTL)',
    category: 'Radio',
    tier: 'Premium Vertical',
    reach: 'Weather radar',
    description: 'Real-time weather tracking',
  },

  // Financial
  {
    name: 'IEX.nl',
    category: 'Finance',
    tier: 'Premium Vertical',
    reach: 'Investment platform',
    description: 'Stock market & investment news',
  },
]

export const metrics = {
  humanSignals: 279452,
  uplift: 33,
  confidence: 97.5,
  pValue: 0.034, // < 0.05
}

export interface AudiencePersona {
  name: string
  tagline: string
  description: string
  interests: string[]
  publishers: string[]
  index: number
  color: string
  icon: 'wine' | 'newspaper' | 'coins'
}

export const audiencePersonas: AudiencePersona[] = [
  {
    name: 'The Bon Vivant',
    tagline: 'Living the good life',
    description:
      'Enjoys culinary experiences, fine dining, and quality lifestyle content. Values authenticity and craftsmanship in food and wine.',
    interests: [
      'Gourmet cooking',
      'Wine & dining',
      'Culinary travel',
      'Quality ingredients',
    ],
    publishers: ["Laura's Bakery", 'Miljuschka', 'Eef Kookt Zo', 'Rutger Bakt'],
    index: 185,
    color: 'amber',
    icon: 'wine',
  },
  {
    name: 'The Informed Citizen',
    tagline: 'Staying connected & aware',
    description:
      'Actively follows current affairs and values trusted journalism. Seeks comprehensive news coverage and in-depth analysis.',
    interests: [
      'National news',
      'Politics',
      'Current affairs',
      'Investigative journalism',
    ],
    publishers: [
      'RTL Nieuws & Entertainment',
      'Welingelichte Kringen',
      'FOK!',
      'Headliner.nl',
    ],
    index: 140,
    color: 'blue',
    icon: 'newspaper',
  },
  {
    name: 'The Smart Investor',
    tagline: 'Building financial security',
    description:
      'Focused on wealth management, retirement planning, and smart financial decisions. Values expert analysis and actionable insights.',
    interests: [
      'Pension planning',
      'Investment strategy',
      'Financial markets',
      'Wealth management',
    ],
    publishers: ['IEX.nl'],
    index: 250,
    color: 'emerald',
    icon: 'coins',
  },
]
